document.addEventListener("DOMContentLoaded", function () {
  const facetMap = {
    product_category: "product_categories",
    product_season: "product_season",
  };

  // Function to create a custom checkbox item
  function createCheckbox(id, label, dataValue) {
    const choiceItem = document.createElement("div");
    choiceItem.className = "choice-item";

    const checkbox = document.createElement("div");
    checkbox.className = "custom-checkbox";
    checkbox.id = id;
    checkbox.setAttribute("role", "checkbox");
    checkbox.setAttribute("aria-checked", "false");
    checkbox.setAttribute("data-value", dataValue);

    const labelElement = document.createElement("label");
    labelElement.setAttribute("for", id);
    labelElement.className = "body-m-regular";
    labelElement.textContent = label;

    choiceItem.appendChild(checkbox);
    choiceItem.appendChild(labelElement);

    return { choiceItem, checkbox };
  }

  // Function to handle toggling the checkbox state
  function toggleCheckbox(checkbox, choiceItem, facetItem, dataValue) {
    const isChecked = choiceItem.classList.contains("checked");
    const newCheckedState = !isChecked;

    // Toggle the custom checkbox state

    // Trigger the corresponding FacetWP checkbox
    const facetSelector = `.facetwp-facet-${facetItem} .facetwp-checkbox[data-value="${dataValue}"]`;
    const facetItemElement = document.querySelector(facetSelector);

    if (facetItemElement) {
      facetItemElement.click(); // Trigger the FacetWP checkbox click
      if (newCheckedState) {
        choiceItem.classList.add("checked");
        checkbox.setAttribute("aria-checked", "true");
      } else {
        choiceItem.classList.remove("checked");
        checkbox.setAttribute("aria-checked", "false");
      }
    }
  }

  // Function to populate the custom filter checkboxes
  function populateCustomFilters() {
    Object.entries(facetMap).forEach(([customItem, facetName]) => {
      const facetSelector = `.facetwp-facet-${facetName} .facetwp-checkbox`;
      const facetItems = document.querySelectorAll(facetSelector);
      const customFilterList = document.querySelector(
        `.filter-item-list[data-item="${customItem}"]`
      );
      if (!customFilterList) return;

      customFilterList.innerHTML = ""; // Clear existing items

      facetItems.forEach((facetItem, index) => {
        const facetLabel = facetItem
          .querySelector(".facetwp-display-value")
          .textContent.trim();
        const dataValue = facetItem.getAttribute("data-value");

        const { choiceItem, checkbox } = createCheckbox(
          `choice-${customItem}-${index}`,
          facetLabel,
          dataValue
        );
        customFilterList.appendChild(choiceItem);

        // Sync custom checkbox with FacetWP checkbox state
        const isChecked = facetItem.classList.contains("facetwp-checked");
        if (isChecked) {
          choiceItem.classList.add("checked");
          checkbox.setAttribute("aria-checked", "true");
        }

        // Add click event listener to handle checkbox toggle
        checkbox.addEventListener("click", function () {
          toggleCheckbox(checkbox, choiceItem, facetName, dataValue);
        });
      });
    });
  }

  // Listen for FacetWP load event and initialize filter states
  document.addEventListener("facetwp-loaded", function () {
    populateCustomFilters(); // Populate custom filters when FacetWP is loaded
  });
});
